
























































































































import AuthService from '@/services/auth-service'
import SnackbarService from '@/services/snackbar-service'
import { Component, Mixins } from 'vue-property-decorator'
import CowIcon from '@/components/CowIcon.vue'

@Component({
  components: {
    CowIcon,
  },
})
export default class LandingPageView extends Mixins(
  AuthService,
  SnackbarService
) {
  carousel = 0
  slides = [
    {
      text:
        'Simply manage all your cow data, like pregnancy, irons, color, ...',
      color: 'white',
    },
    { text: 'View statistics about each of your farms', color: 'white' },
    {
      text: 'Keep track when you reviewed your cows the last time',
      color: 'white',
    },
    { text: 'See pregnancy chart', color: 'white' },
    { text: 'Offline usage possible', color: 'white' },
  ]
  mounted() {
    this.$store.state.showAppbar = false
  }
}
